import React from 'react'
import { Switch as SwitchPrimitive } from '@radix-ui/react-switch'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

const useStyles = createUseStyles({
    switchRoot: {
        all: 'unset',
        width: '42px',
        height: '18px',
        backgroundColor: 'white',
        borderRadius: '9999px',
        border: '1px solid #e0e0e0',
        position: 'relative',
        boxShadow: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        cursor: 'pointer',
        '&[data-state="checked"]': {
            backgroundColor: colors.green,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '-3px',
            left: '0',
            width: '23px',
            height: '23px',
            backgroundColor: 'white',
            borderRadius: '9999px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.15)',
            transition: 'transform 200ms',
            transform: 'translateX(0)',
        },
        '&[data-state="checked"]::before': {
            transform: 'translateX(19px)',
        },
    },
    label: {
        color: '#666666',
        fontSize: '14px',
        lineHeight: 1.4,
        userSelect: 'none',
        fontWeight: 'normal',
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 0',
        position: 'relative',
    },
    leftSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    helpIcon: {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        border: '1px solid #cccccc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#666666',
        fontSize: '12px',
        cursor: 'help',
    },
})

// The complete reusable component
const SwitchComponent: React.FC<{
    id: string
    label: string
    checked?: boolean
    onCheckedChange?: (checked: boolean) => void
    className?: string
    labelClassName?: string
}> = ({
    id,
    label,
    checked,
    onCheckedChange,
    className = '',
    labelClassName = '',
}): React.ReactElement => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <div className={classes.leftSection}>
                <label
                    className={`${classes.label} ${labelClassName}`}
                    htmlFor={id}
                >
                    {label}
                </label>
            </div>
            <SwitchPrimitive
                className={`${classes.switchRoot} ${className}`}
                id={id}
                checked={checked}
                onCheckedChange={onCheckedChange}
                data-state={checked ? 'checked' : 'unchecked'}
            />
        </div>
    )
}

// Export both the primitive component and the complete component
const Switch = {
    Root: SwitchPrimitive,
    Thumb: SwitchPrimitive, // In older version, this is the same as Root
    Component: SwitchComponent,
}

export default Switch
